import { useChatSupport } from "../../../context/chat-support/chat-support.context";
import { ChatStatus } from "../../../entities/chat-support.entity";
import { Badge } from "../../shared/atoms/badge";
import { UserCardWithImageAndName } from "../../shared/molecules/user-card-with-profile-name";
import { ActiveChatHeaderMenu } from "./active-chat-header-menu";

export const ActiveChatHeader = () => {
  const {
    states: {
      activeChatRoom: { activeChatRoom },
    },
  } = useChatSupport();

  return (
    <div className="drop-shadow-md flex-col     w-full flex md:flex-row  z-50 items-center gap-2 rounded-t-lg p-4 bg-white border-b">
      <UserCardWithImageAndName user={activeChatRoom.user} clickable={true}>
        <span className="text-gray-400  text-xs   break-words">{activeChatRoom.user.email}</span>
      </UserCardWithImageAndName>

      <div className="md:ms-auto flex_center flex gap-2">
        <Badge
          className=" me-4  rounded-md  h-max  "
          color={
            activeChatRoom.user.roles.includes("COACH") && activeChatRoom.user.roles.includes("LEARNER")
              ? "blue"
              : activeChatRoom.user.roles.includes("COACH")
              ? "pink"
              : "purple"
          }
          children={
            activeChatRoom.user.roles.includes("COACH") && activeChatRoom.user.roles.includes("LEARNER")
              ? "Dual"
              : activeChatRoom.user.roles.includes("COACH")
              ? "Coach"
              : "Learner"
          }
        />
        <Badge
          className=" rounded-md"
          isDot
          color={activeChatRoom.status === ChatStatus.OPEN ? "green" : "gray"}
          children={activeChatRoom.status === ChatStatus.OPEN ? "Open" : "Closed"}
        />

        <ActiveChatHeaderMenu status={activeChatRoom.status} />
      </div>
    </div>
  );
};
